const faqs = [
  {
    title: '¿Qué hace esta plataforma y como puedes ayudarme?',
    content: (
      <p>
        Somos una alternativa de educación enfocada en hacerte un Frontend excelente, nuestra guía de estudio es profunda, ordenada y cuenta con una serie de proyectos para que no quede en duda tu aprendizaje. Te enseñamos cómo y por qué escribes el código que escribes.
      </p>
    ),
  },
  {
    title: '¿Qué necesito para tomar los cursos?',
    content: (
      <p>
        Un computador con cualquier especificación de hardware o sistema operativo donde puedas tener un navegador como Google Chrome y un editor de código como Visual Studio Code.
      </p>
    ),
  },
  {
    title: '¿Cómo evalúan mi aprendizaje?',
    content: (
      <p>
        Cada curso o taller lleva anexo un proyecto de
        <a href="https://leonidasesteban.com/proyectos/todos" target="_blank" rel="noopener noreferrer"> aquí </a>
        donde desarrollamos cierto porcentaje del mismo y te dejamos unos cuantos módulos para que tú practiques
        {' '}
        y sumado el sistema de evaluación 1 a 1 vemos tu código para darte feedback o celebrar tus logros.
      </p>
    ),
  },
  {
    title: '¿Entregan certificados al finalizar el curso?',
    content: (
      <div>
        <p>
          Sí, una vez completes el curso y que tu proyecto del curso sea aprobado, lo recibiras y podras compartirlo en Linkedin y tus redes sociales,
          puedes ver tus certificados
          {' '}
          <a href="/estudiante#certificados" target="_blank" rel="noopener noreferrer">aquí.</a>
        </p>
      </div>
    ),
  },
  {
    title: '¿Cuentan con cursos gratuitos?',
    content: (
      <p>
        Claro,
        {' '}
        <a href="https://leonidasesteban.com/cursos/figma-frontends" target="_blank" rel="noopener noreferrer">experimenta</a>
        {' '}
        nuestro sistema de enseñanza ya mismo y hasta
        {' '}
        <a href="https://leonidasesteban.com/blog/becas-por-estudiar" target="_blank" rel="noopener noreferrer">becas</a>
        {' '}
        para quienes gozan de aprender
      </p>
    ),
  },
  {
    title: '¿Qué precio tiene cada proyecto, existe alguna suscripción o pago mensual/anual?',
    content: (
      <p>
        Puedes comprar el acceso a todos los proyectos por 48usd al mes
        {' '}
        <a href="https://leonidasesteban.com/comprar/proyectos" target="_blank" rel="noopener noreferrer">aquí</a>
        , pero te recomendamos la
        {' '}
        <a href="https://leonidasesteban.com/comprar/anual" target="_blank" rel="noopener noreferrer">Suscripción Anual</a>
        {' '}
        que incluye también cursos y talleres donde se desarrollan los mismos.
      </p>
    ),
  },
  {
    title: '¿Qué métodos de pago aceptan?',
    content: (
      <p>Tarjetas de crédito/debito Visa y Mastercard a nivel mundial, Paypal como 2do recurso y transferencia bancaria solo en México, Colombia y Perú.</p>
    ),
  },
  {
    title: '¿Puedo pagar la suscripción a mensualidades?',
    content: (
      <div>
        <p>Si estas en México tu tarjeta de credito automáticamente va a diferir el pago a 6 meses sin intereses.</p>
        <p>
          Puedes pagar a 3, 4, 5, 6 meses la suscripción anual con cualquier tarjeta de debito y
          de credito desde cualquier parte del mundo con nuestros planes de financiamiento.
        </p>
        <p>
          Consulta
          {' '}
          <a href="/terminos#planes-de-financiamiento" target="_blank" rel="noopener noreferrer">Terminos y Condiciones</a>
          {' '}
          de los planes de financiamiento para que no pierdas el acceso a tu suscripción anual.
        </p>
      </div>
    ),
  },
  {
    title: 'Ya he pagado, ¿Qué hago ahora?',
    content: (
      <p>
        <a href="https://leonidasesteban.com/aprender" target="_blank" rel="noopener noreferrer">Elige tu curso</a>
        {' '}
        o
        {' '}
        <a href="https://leonidasesteban.com/proyectos/todos" target="_blank" rel="noopener noreferrer">Proyecto</a>
        {' '}
        a iniciar.
        <b> No Te Rindas.</b>
      </p>
    ),
  },
  {
    title: '¿La suscripción se renueva automáticamente?',
    content: <p>Sí, cada ciclo mensual o anual según hayas elegido.</p>,
  },
  {
    title: '¿Dónde puedo obtener ayuda estoy atorado en mi proyecto?',
    content: (
      <p>Tenemos un servidor de Discord donde hacemos live coding, respondemos preguntas y charlamos en general. Desde tu perfil puedes vincular y unirte al server.</p>
    ),
  },
  {
    title: '¿Cómo envió, edito o elimino mi proyecto?',
    content: (
      <p>
        Este es el tutorial de
        {' '}
        <a href="https://leonidasesteban.com/blog/como-usar-proyectos-en-3-pasos" target="_blank" rel="noopener noreferrer">como funciona el sistema de /Proyectos.</a>
      </p>
    ),
  },
  {
    title: '¿Los proyectos son de libre uso o debo hacer alguna mención al autor?',
    content: (
      <p>
        Agradecemos cualquier mención a
        <span className="underline"> leonidasesteban.com</span>
        , pero no es obligatoria.
      </p>
    ),
  },
  {
    title: '¿Cómo pausar temporalmente mi suscripción?',
    content: <p>¿Cómo pausar temporalmente mi suscripción?</p>,
  },
  {
    title: '¿Cómo puedo borrar mi cuenta?',
    content: (
      <p>
        Escríbeme a
        {' '}
        <a href="mailto:me@leonidasesteban.com" className="email">me@leonidasesteban.com</a>
      </p>
    ),
  },
  {
    title: '¿No encontró respuesta a su pregunta?',
    content: (
      <p>
        El último recurso es escribirme a
        {' '}
        <a href="mailto:me@leonidasesteban.com" className="email">me@leonidasesteban.com</a>
        {' '}
        voy a intentar ser lo más honesto para ayudarte, pero estoy seguro de que el sistema de comentarios y discord son más veloces y muy bien capacitados para ayudarte.
      </p>
    ),
  },
]

export default faqs
